export default "__VITE_ASSET__DzO4ZoZ6__"